module.exports = __webpack_public_path__ + "img/rincian-1.5bf9ec6d.jpg";